// extracted by mini-css-extract-plugin
export default {"title-node-container":"TitleNode_title-node-container__04jJD","label":"TitleNode_label__AeVFv"};